import AxiosClient from "../../../services/axios.services";

class EvaluationValueServices {

  //valores del empleado
  getEmployeeValue = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_despliegue_valores_empleado/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getEmployeeValueById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_despliegue_valores_empleado/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveEmployeeValue = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_despliegue_valores_empleado/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editEmployeeValue = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_despliegue_valores_empleado/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteEmployeeValue = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_despliegue_valores_empleado/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );




  //valores del jefe
  getBossValue = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_despliegue_valores_jefe/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getBossValueById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_despliegue_valores_jefe/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveBossValue = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_despliegue_valores_jefe/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editBossValue = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_despliegue_valores_jefe/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteBossValue = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_despliegue_valores_jefe/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new EvaluationValueServices();
